
import React, { useEffect, useState } from 'react'; // React is now imported
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import axios from 'axios';
import { CONFIG } from '../config'
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';

const RiskRegisterFormForEvaluateSub = ({ dataForRegisterFormEval, globalCentreId}) => {

//   const selectedRiskHierarchy = hierarchyData.find((item) => item.id === selectedRiskHierarchyIdForRisk);
//   const selectedRegisterIdd = registerDetailId ? registerDetailId : selectedRegisteredId;
//   const selectedRegister = allRegister.find((item) => item.id === selectedRegisterIdd);
  //console.log(selectedRegister)
  //console.log(selectedRiskHierarchy);

  console.log(dataForRegisterFormEval);
  
  
  const [allEntityData, setAllEntityData] = useState([]);

  async function getEntityData() {
    if (CONFIG.SYSTEM_WITH_MENU_SYSTEM) {
      try {
        const entityList = await axios.get(`${CONFIG.MAIN_URL}/consolidatedCompanyEntity/filter?schoolId=${globalCentreId}`);
        console.log(entityList);
        
        const tmpEntityData = [];
        for (const item of entityList.data) {
            if (item.isActive && item.schoolId === globalCentreId){
                const basicEntity = item.basicEntityId;
                const basicentityList = await axios.get(`${CONFIG.MAIN_URL}/basicEntity/filter?schoolId=${globalCentreId}`); 
                const findBasicEntity = basicentityList.data.find(basic => basic.basicEntityId === basicEntity)
                const arrayData = {
                    entityId: item.entityId,
                    entityName: item.entityName,
                    isActive: item.isActive,
                    createdBy: item.createdBy,
                    centreId: item.schoolId,
                    lastModifiedBy: item.lastModifiedBy,
                    basicEntity : {
                      basicEntityId: findBasicEntity.basicEntityId,
                      entityName: findBasicEntity.entityName,
                      iamRole: findBasicEntity.iamRole,
                      forceIamRole: findBasicEntity.forceIamRole,
                    }

                };

                tmpEntityData.push(arrayData);
            }
        }
       
        console.log(tmpEntityData);
        var tmpEntityData1 = [];
        tmpEntityData.forEach((item, index)=>{
          if (item.isActive && item.centreId === globalCentreId){
                var be = item.basicEntity
                var forceIamRole = item.basicEntity.forceIamRole;
                var iamRole = item.basicEntity.iamRole;  
                var canTake = true;
                if ((iamRole === "parent") || (iamRole === "ADMIN" && forceIamRole === "ADMIN") || (iamRole === "supplier" && forceIamRole === "supplier") || (iamRole === "serviceprovider" && forceIamRole === "serviceprovider") || (iamRole === "volunteer" && forceIamRole === "volunteer")){
                  canTake = false;
                }
                if (canTake){
                  var arrayData = {}
                  arrayData["entityId"] = item.entityId;
                  arrayData["entityName"] = item.entityName;
                  tmpEntityData1.push(arrayData);
                }  
            }
        })
        console.log(tmpEntityData1);
        setAllEntityData(tmpEntityData1);
    } catch (error) {
        console.error("Error fetching entity list:", error);
    }
    }else{
    var data = '{allEntityList{ entityDataList{entityName,entityId,isActive,createdBy,lastModifiedBy,centreId,basicEntity{basicEntityId,entityName,iamRole,forceIamRole}}}}';
    axios(CONFIG.MAIN_URL + '/graphql', {
      method: 'post',
      headers: {
        'Content-Type': 'text/plain',
      },
      data: data,
    })
      .then(function (response) {
        var entityList = response.data.data.allEntityList.entityDataList;
        var tmpEntityData = [];
        entityList.forEach((item, index) => {
          if (item.isActive && item.centreId === globalCentreId){
            var be = item.basicEntity
            var forceIamRole = item.basicEntity.forceIamRole;
            var iamRole = item.basicEntity.iamRole;
            var canTake = true;
            if ((iamRole === "ADMIN" && forceIamRole === "ADMIN") || (iamRole === "supplier" && forceIamRole === "supplier") || (iamRole === "serviceprovider" && forceIamRole === "serviceprovider") || (iamRole === "volunteer" && forceIamRole === "volunteer")) {
              canTake = false;
            }
            if (canTake) {
              var arrayData = {};
              arrayData["entityId"] = item.entityId;
              arrayData["entityName"] = item.entityName;
              tmpEntityData.push(arrayData);
            }
          }
        })
        setAllEntityData(tmpEntityData);

      })
      .catch(function (error) {
        
      });
  }
  }

  useEffect (() => {
    getEntityData()

  },[])


  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  const uniqueEntityNames = Array.from(
    new Set(allEntityData.map((data) => data.entityName))
  ).filter((name) => name !== "superadmin");

  const [formData, setFormData] = useState({
    riskReference: dataForRegisterFormEval?.value.generalInformation?.riskReference || "",
    riskCategory: dataForRegisterFormEval?.value.generalInformation?.riskCategory || "",
    objectivesAffected: dataForRegisterFormEval?.value.generalInformation?.objectivesAffected || "",
    likelihood: dataForRegisterFormEval?.value.assessment?.riskLikelihood || "",
    impact: dataForRegisterFormEval?.value.assessment?.riskImpact || "",
    riskAppetite: dataForRegisterFormEval?.value.assessment?.riskAppetite || "",
    currentControls: dataForRegisterFormEval?.value.currentControls?.currentControls || "",
    controlEffectiveness: dataForRegisterFormEval?.value.currentControls?.controlEffectiveness || "",
    mitigation: dataForRegisterFormEval?.value.mitigationActions?.mitigation || "",
    actionOwner: dataForRegisterFormEval?.value.mitigationActions?.actionOwner || "",
    targetCompletionDate: dataForRegisterFormEval?.value.mitigationActions?.targetCompletionDate || "",
    status: dataForRegisterFormEval?.value.mitigationActions?.status || "",
    reviewFrequency: dataForRegisterFormEval?.value.monitoringAndReview?.reviewFrequency || "",
    lastReviewDate: dataForRegisterFormEval?.value.monitoringAndReview?.lastReviewDate || "",
    nextReviewDate: dataForRegisterFormEval?.value.monitoringAndReview?.nextReviewDate || "",
    KRIs: Array.isArray(dataForRegisterFormEval?.value.monitoringAndReview?.kris) ? dataForRegisterFormEval?.value.monitoringAndReview?.kris.map((data) => data.keyIndicator) : [],
    supportingDocumentation: Array.isArray(dataForRegisterFormEval?.value.monitoringAndReview?.supportingDocumentation) ? dataForRegisterFormEval?.value.monitoringAndReview?.supportingDocumentation.map((data) => data.supportingDocument) : [],
    revisionHistory: Array.isArray(dataForRegisterFormEval?.value.auditTrail) ? dataForRegisterFormEval?.value.auditTrail : []
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "likelihood" || name === "impact") {
      const likelihood = name === "likelihood" ? parseInt(value) || 0 : formData.likelihood;
      const impact = name === "impact" ? parseInt(value) || 0 : formData.impact;
      setFormData({ ...formData, riskLevel: likelihood * impact, [name]: value });
    }
  };

  const handleKRIChange = (index, value) => {
    setFormData({
      ...formData,
      KRIs: formData.KRIs.map((item, i) => (i === index ? value : item)),
    });
  };

  const handleRevisionChange = (index, field, value) => {
    const updatedHistory = [...formData.revisionHistory];
    updatedHistory[index][field] = value;
    setFormData({ ...formData, revisionHistory: updatedHistory });
  };

  const exportToExcel = (formData) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Risk Register");
  
    const riskData = [
      ["", formData.riskCategory, ""],
      ["Section", "Field Name", "Value"],
      ["General Information", "Risk Reference", formData.riskReference],
      ["General Information", "Risk Category", formData.riskCategory],
      ["General Information", "Objectives Affected", formData.objectivesAffected],
      [],
      ["Risk Assessment", "Likelihood", formData.likelihood],
      ["Risk Assessment", "Impact", formData.impact],
      ["Risk Assessment", "Risk Appetite", formData.riskAppetite],
      ["Risk Assessment", "Risk Level", formData.likelihood * formData.impact],
      [],
      ["Current Controls", "Current Controls", formData.currentControls],
      ["Current Controls", "Control Effectiveness", formData.controlEffectiveness],
      [],
      ["Mitigation Actions", "Mitigation", formData.mitigation],
      ["Mitigation Actions", "Action Owner", formData.actionOwner],
      ["Mitigation Actions", "Target Completion Date", formData.targetCompletionDate.split("T")[0]],
      ["Mitigation Actions", "Status", formData.status],
      [],
      ["Monitoring & Review", "Review Frequency", formData.reviewFrequency],
      ["Monitoring & Review", "Last Review Date", formData.lastReviewDate.split("T")[0]],
      ["Monitoring & Review", "Next Review Date", formData.nextReviewDate.split("T")[0]],
    ];
  
    riskData.forEach((row, index) => {
      const newRow = worksheet.addRow(row);
      newRow.eachCell((cell) => {
        cell.alignment = { horizontal: "left" };
      });
  
  
      if (index === 0) {
        newRow.eachCell((cell) => {
          cell.font = { bold: true, color: { argb: "FF0000FF" } }; 
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFB6D7A8" }, 
          };
        });
      } else if (index === 1) {
        newRow.eachCell((cell) => {
          cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; 
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF4F81BD" }, 
          };
        });
      }
    });
  
 
    if (formData.KRIs.length > 0) {
      worksheet.addRow(["Monitoring & Review", "KRIs", formData.KRIs[0]]);
      for (let i = 1; i < formData.KRIs.length; i++) {
        worksheet.addRow(["", "", formData.KRIs[i]]);
      }
    }
  
    if (formData.supportingDocumentation.length > 0) {
      worksheet.addRow(["Monitoring & Review", "Supporting Documentation", formData.supportingDocumentation[0]]);
      for (let i = 1; i < formData.supportingDocumentation.length; i++) {
        worksheet.addRow(["", "", formData.supportingDocumentation[i]]);
      }
    }
  
    if (formData.revisionHistory.length > 0) {
      worksheet.addRow(["Monitoring & Review", "Revision History"]);
      worksheet.addRow(["", "Revision Date", "Revised By", "Changes Made"]);
      formData.revisionHistory.forEach((revision) => {
        worksheet.addRow([
          "",
          revision.revisionDate.split("T")[0],
          revision.revisedBy,
          revision.changesMade,
        ]);
      });
    }
  
    worksheet.columns = [
      { width: 20 },
      { width: 30 },
      { width: 100 },
    ];
  
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      saveAs(blob, `${formData.riskCategory}.xlsx`);
    });
  };
  
  
  



  return (
    <Box sx={{ marginTop: "-30px" }}>

      <Grid container spacing={1}>
      <Grid item xs={12}>
          <Stack direction="row" spacing={2}
            justifyContent="space-between">
                <div style={{fontWeight: "bold", color:'black'}}>
                  
                </div>
                <div>
                <Button
                variant="contained"
                color="primary"
                style={{fontSize: '9px'}}
                onClick={() => exportToExcel(formData)}
                >
                Export to Excel
                </Button>
                </div>
          </Stack>
        </Grid>
        <Grid item xs={6}>

          <Card
            style={{
              width: "100%",
              backgroundColor: "#f8d7da",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
                <Grid item xs={12}  >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#d9534f",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}
                  >General Information</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Reference</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="riskReference"
                    name="riskReference"
                    value={formData.riskReference}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Category</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="riskCategory"
                    name="riskCategory"
                    value={formData.riskCategory}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Objectives Affected</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="objectivesAffected"
                    name="objectivesAffected"
                    value={formData.objectivesAffected}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#fff3cd",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >




                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#f0ad4e",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Risk Assessment</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Likelihood</Grid>
                <Grid item xs={8}>
                  <input
                    type="number"
                    min={1}
                    max={5}
                    id="likelihood"
                    name="likelihood"
                    value={formData.likelihood}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>

                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Impact</Grid>
                <Grid item xs={8}>
                  <input
                    type="number"
                    min={1}
                    max={5}
                    id="impact"
                    name="impact"
                    value={formData.impact}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>

                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Appetite</Grid>
                <Grid item xs={8}>
                  <input
                    type="number"
                    min={1}
                    max={5}
                    id="riskAppetite"
                    name="riskAppetite"
                    value={formData.riskAppetite}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>

                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Appetite</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="riskLevel"
                    name="riskLevel"
                    value={formData.likelihood * formData.impact}
                    //onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#d4edda",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >

                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#5cb85c",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Current Controls</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Current Controls</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="currentControls"
                    name="currentControls"
                    value={formData.currentControls}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Control Effectiveness</Grid>
                <Grid item xs={8}>
                  <select
                    id="controlEffectiveness"
                    name="controlEffectiveness"
                    //value={formData.controlEffectiveness}
                    //onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px' }}
                  >
                    {formData.controlEffectiveness === 'Highly Effective' ?
                      <option value="Highly Effective" selected>Highly Effective</option>
                      :
                      <option value="Highly Effective" >Highly Effective</option>
                    }
                    {formData.controlEffectiveness === 'Moderately Effective' ?
                      <option value="Moderately Effective" selected>Moderately Effective</option>
                      :
                      <option value="Moderately Effective" >Moderately Effective</option>
                    }
                    {formData.controlEffectiveness === 'Needs Improvement' ?
                      <option value="Needs Improvement" selected>Needs Improvement</option>
                      :
                      <option value="Needs Improvement" >Needs Improvement</option>
                    }
                  </select >
                </Grid>

              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#d1ecf1",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >

                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#5bc0de",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Mitigation Actions</Typography>
                </Grid>



                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Mitigation Actions</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="mitigation"
                    name="mitigation"
                    value={formData.mitigation}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>

                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Action Owner</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="actionOwner"
                    name="actionOwner"
                    value={formData.actionOwner}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Target Completion Date</Grid>
                <Grid item xs={8}>
                  <input
                    type="date"
                    id="actionOwner"
                    name="actionOwner"
                    value={formData.targetCompletionDate ? formatDate(formData.targetCompletionDate.split("T")[0]) : ""}
                    //onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>

                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Status</Grid>
                <Grid item xs={8}>
                  <select
                    id="status"
                    name="status"
                    style={{ fontSize: '9px', height: '20px' }}
                  >
                    {formData.status === 'Not Started' ?
                      <option value="Not Started" selected>Not Started</option>
                      :
                      <option value="Not Started" >Not Started</option>
                    }
                    {formData.status === 'In Progress' ?
                      <option value="In Progress" selected>In Progress</option>
                      :
                      <option value="In Progress" >In Progress</option>
                    }
                    {formData.status === 'Completed' ?
                      <option value="Completed" selected>Completed</option>
                      :
                      <option value="Completed" >Completed</option>
                    }
                  </select >
                </Grid>






              </Grid>
            </CardContent>
          </Card>
        </Grid> 
   
        <Grid item xs={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#e2e3e5",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >

                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#6c757d",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Monitoring & Review</Typography>
                </Grid>

                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Review Frequency</Grid>
                <Grid item xs={8}>
                  <select
                    id="reviewFrequency"
                    name="reviewFrequency"
                    style={{ fontSize: '9px', height: '20px' }}
                  >

                    {formData.reviewFrequency === 'Quarterly' ?
                      <option value="Quarterly" selected>Quarterly</option>
                      :
                      <option value="Quarterly" >Quarterly</option>
                    }
                    {formData.reviewFrequency === 'Semi-Annually' ?
                      <option value="Semi-Annually" selected>Semi-Annually</option>
                      :
                      <option value="Semi-Annually" >Semi-Annually</option>
                    }
                    {formData.reviewFrequency === 'Annually' ?
                      <option value="Annually" selected>Annually</option>
                      :
                      <option value="Annually" >Annually</option>
                    }
                  </select >
                </Grid>




                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Last Review Date</Grid>
                <Grid item xs={8}>
                  <input
                    type="date"
                    id="lastReviewDate"
                    name="lastReviewDate"
                    value={formData.lastReviewDate ? formatDate(formData.lastReviewDate.split("T")[0]) : ""}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>

                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Next Review Date</Grid>
                <Grid item xs={8}>
                  <input
                    type="date"
                    id="nextReviewDate"
                    name="nextReviewDate"
                    value={formData.nextReviewDate ? formatDate(formData.nextReviewDate.split("T")[0]) : ""}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>KRIs (Key Risk Indicators)</Grid>
                {formData.KRIs.map((kri, index) => (
                  <>
                    {index === 0 ?
                      <Grid item xs={8}>
                        <input
                          type="text"
                          value={kri}
                          style={{ fontSize: '9px', height: '12px' }}
                        />
                      </Grid>
                      :
                      <>
                        <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>&nbsp;</Grid>
                        <Grid item xs={8}>
                          <input
                            type="text"
                            value={kri}
                            style={{ fontSize: '9px', height: '12px' }}
                          />
                        </Grid>

                      </>
                    }
                  </>
                ))}

<Grid item xs={12} style={{ fontSize: '9px', color: '#2a3f54' }}>Supporting Documentation</Grid>

<Grid item xs={12} >
  {formData.supportingDocumentation.map((doc, index) => (
    <Stack direction="row" spacing={2} alignItems="center" key={index}>
      <Box sx={{ flexGrow: 1 }}>
        {typeof doc === 'string' ? (
          <Typography variant="body2" sx={{ mt: 1 }}>
            <a href={doc} target="_blank" rel="noopener noreferrer">
              {doc.split('/').pop()} 
            </a>
          </Typography>
        ) : (       
          <>
            <input
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.png"
              onChange={(e) => {
                const uploadedFile = e.target.files[0];
                setFormData({
                  ...formData,
                  supportingDocumentation: formData.supportingDocumentation.map(
                    (item, i) => (i === index ? uploadedFile : item)
                  ),
                });
              }}
            />
            {doc && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                {doc.name}
              </Typography>
            )}
          </>
        )}
      </Box>

    </Stack>
  ))}

</Grid>


              </Grid>
            </CardContent>
          </Card>
        </Grid>
        

        <Grid item xs={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#c7beef",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
              
              <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#3f1eda",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Audit Trail</Typography>
                </Grid>
                
                
                
                <Grid item xs={12} >
          <Table style={{ marginTop: '-5px' }}>
            <TableHead>
              <TableRow style={{ height: '12px'}}>
                <TableCell style={{ fontSize: '9px', width: '20%', color: '#2a3f54', height: '12px', paddingTop: '0px', paddingBottom: '0px' }}>Revision Date</TableCell>
                <TableCell style={{ fontSize: '9px', width: '20%', color: '#2a3f54', height: '12px', paddingTop: '0px', paddingBottom: '0px' }}>Revised By</TableCell>
                <TableCell style={{ fontSize: '9px', width: '60%', color: '#2a3f54', height: '12px', paddingTop: '0px', paddingBottom: '0px' }}>Changes Made</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formData.revisionHistory.map((revision, index) => (
                <TableRow key={index}>
                  <TableCell style={{ height: '12px', paddingTop: '1px', paddingBottom: '1px' }}>
                  <input
                    type="text"
                    value={revision.revisionDate.split("T")[0]}
                    onChange={(e) => handleRevisionChange(index, "revisionDate", e.target.value)}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                    
                  </TableCell>
                  <TableCell style={{ height: '12px', paddingTop: '1px', paddingBottom: '1px' }}>

                  <input
                    type="text"
                    value={revision.revisedBy}
                    onChange={(e) => handleRevisionChange(index, "revisedBy", e.target.value)}
                    style={{ fontSize: '9px', height: '12px' }}
                  />

                  </TableCell>
                  <TableCell style={{ height: '12px', paddingTop: '1px', paddingBottom: '1px' }}>

                  <input
                    type="text"
                    value={revision.changesMade}
                    onChange={(e) => handleRevisionChange(index, "changesMade", e.target.value)}
                    style={{ fontSize: '9px', height: '12px' }}
                  />

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
                </Grid>
              
              
              



                </Grid>
            </CardContent>
          </Card>
          </Grid>            
   


      </Grid>
    </Box>
  );
};

export default RiskRegisterFormForEvaluateSub;
